module.exports =
  QUESTION_TAG_ITEM_DND_TYPE: 'questionTagItem'

  dragSpec:
    beginDrag: (props) ->
      itemId: props.itemId
      index: props.index
      tagType: props.tagType

    canDrag: (props) ->
      props.canDrag

    isDragging: (props, monitor) ->
      props.itemId is monitor.getItem().itemId

  dropSpec:
    hover: (props, monitor, component) ->
      return unless props.canDrag
      return unless component?.item

      draggingItem = monitor.getItem()
      return unless draggingItem.tagType is props.tagType

      dragIndex = draggingItem.index
      hoverIndex = props.index

      return if dragIndex is hoverIndex

      hoverBoundingRect = component.item.getBoundingClientRect()
      hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2
      clientOffset = monitor.getClientOffset()
      return unless clientOffset?

      hoverClientY = clientOffset.y - hoverBoundingRect.top

      if dragIndex < hoverIndex and hoverClientY < hoverMiddleY
        return
      if dragIndex > hoverIndex and hoverClientY > hoverMiddleY
        return

      props.onMoveTag { dragIndex, hoverIndex }
      draggingItem.index = hoverIndex

  dragCollect: (connect, monitor) ->
    connectDragSource: connect.dragSource()
    isDragging: monitor.isDragging()

  dropCollect: (connect, monitor) ->
    connectDropTarget: connect.dropTarget()
    isOver: monitor.isOver()
